import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { STORAGE_KEY } from "@/hooks/useAppVersion";

const ACK_KEY = "app:acknowledged_backend_version";

export default function UpdateBanner() {
  const [visible, setVisible] = useState(false);
  const [versionId, setVersionId] = useState(null);

  useEffect(() => {
    const handler = (e) => {
      const nextVersionId = e?.detail?.versionId || null;
      if (nextVersionId) {
        const acknowledged = localStorage.getItem(ACK_KEY);
        if (acknowledged === nextVersionId) return;
      }

      setVisible(true);
      setVersionId(nextVersionId);
    };
    window.addEventListener("app:update_available", handler);
    return () => window.removeEventListener("app:update_available", handler);
  }, []);

  if (!visible) return null;

  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 w-[calc(100%-2rem)] max-w-xl">
      <div className="flex items-center justify-between gap-3 rounded-lg border bg-white px-4 py-3 shadow-lg">
        <div>
          <p className="font-medium text-sm text-slate-900">Nueva versión disponible</p>
          <p className="text-xs text-slate-600">Recarga para ver los últimos cambios.</p>
        </div>
        <div className="flex gap-2">
          <Button variant="outline" size="sm" onClick={() => setVisible(false)}>
            Más tarde
          </Button>
          <Button
            size="sm"
            className="bg-blue-600 hover:bg-blue-700"
            onClick={() => {
              // Mark this backend version as acknowledged to prevent repeated prompts
              if (versionId) localStorage.setItem(ACK_KEY, versionId);
              window.location.reload();
            }}
          >
            Recargar
          </Button>
        </div>
      </div>
    </div>
  );
}
